import gql from 'graphql-tag';

export default gql`
  fragment keyPersonFragment on KeyPerson {
    id
    uuid
    department
    firstName
    lastName
    position
    updatedAt
    facebookUrl
    xUrl
    linkedinUrl
    wantedlyUrl
    eightUrl
    telephoneNumber
  }
`;
